import { render } from "./MobileRightBar.vue?vue&type=template&id=0ec00546&scoped=true"
import script from "./MobileRightBar.vue?vue&type=script&lang=js"
export * from "./MobileRightBar.vue?vue&type=script&lang=js"

import "./MobileRightBar.vue?vue&type=style&index=0&id=0ec00546&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec00546"]])

export default __exports__